/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorAuctionDetailDtoResponseModel } from '../../models/vendor-auction-detail-dto-response-model';

export interface ApiVendorVendorAuctionGetVendorAuctionGet$Params {
  id?: string;
  vendorCode?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorVendorAuctionGetVendorAuctionGet(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionGetVendorAuctionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorAuctionDetailDtoResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionGetVendorAuctionGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('vendorCode', params.vendorCode, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorAuctionDetailDtoResponseModel>;
    })
  );
}

apiVendorVendorAuctionGetVendorAuctionGet.PATH = '/api/vendor/vendor-auction/GetVendorAuction';
